import script from "./LockBidding.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockBidding.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__